import { compareTag } from '../../../utils/compareTag.js';
import { CLASSES, BREADCRUMBS_CONSTANTS } from '../constants/index.js';

function addClass(crumb, className) {
    crumb.classList.add(className);
}
function removeClass(crumb, className) {
    crumb.classList.remove(className);
}
function hasHiddenClass(crumb) {
    return crumb.classList.contains(CLASSES.hidden);
}
function getCrumbs(container) {
    return Array.from(container.children).filter((child) => !child.classList.contains(CLASSES.isDropdown) &&
        !compareTag(child, "svg") &&
        !compareTag(child, "div"));
}
function hideAllCrumbs(crumbs, container, breakpointWidth) {
    const containerWidth = container.offsetWidth;
    crumbs.forEach((crumb, index) => {
        if (containerWidth <= breakpointWidth && !hasHiddenClass(crumb)) {
            addClass(crumb, CLASSES.hidden);
        }
        else if (index > 0 && !hasHiddenClass(crumb)) {
            addClass(crumb, CLASSES.hidden);
        }
    });
}
function calculateTotalCrumbsWidth(crumbs) {
    const notHiddenCrumbs = crumbs.filter((crumb) => !hasHiddenClass(crumb));
    const crumbsWidth = notHiddenCrumbs.reduce((prev, crumb) => {
        return prev + crumb.offsetWidth;
    }, 0);
    const chevronsWidth = BREADCRUMBS_CONSTANTS.CHEVRON_WIDTH * (notHiddenCrumbs.length - 1);
    const dotsWidth = crumbs.length > notHiddenCrumbs.length
        ? BREADCRUMBS_CONSTANTS.DROPDOWN_TRIGGER_WIDTH + BREADCRUMBS_CONSTANTS.CHEVRON_WIDTH
        : 0;
    return crumbsWidth + chevronsWidth + dotsWidth;
}

export { addClass, calculateTotalCrumbsWidth, getCrumbs, hasHiddenClass, hideAllCrumbs, removeClass };
//# sourceMappingURL=utils.js.map
